<router-outlet></router-outlet>

@if (toast$ | async; as toast) {
    @if (toast.show) {
        <adspt-toaster
            [type]="toast.type"
            [title]="toast.title | translate"
            (closed)="hideToast()"
            [duration]="toast.duration"
        />
    }
}
